import { FC, useState } from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faXmark, faCheck } from '@fortawesome/free-solid-svg-icons';
import SettingsItem from '../SettingsItem/SettingsItem';
import globe from '../../images/globe.svg';
import chevronRight from '../../images/chevron_right.svg';
import styles from './SettingsSelect.module.scss';
import TestIds from '../../tests/TestIds';

interface OptionItemProps {
	id: string;
	label: string;
	isSelected: boolean;
	onChange: (id: string) => void;
	closeSelect: () => void;
}

const OptionItem: FC<OptionItemProps> = ({ id, label, isSelected, onChange, closeSelect }) => {
	return (
		<div
			className={classNames(styles.optionItem, { [styles.isSelected]: isSelected })}
			onClick={() => {
				onChange(id);
				closeSelect();
			}}
		>
			{label}
			{isSelected && <FontAwesomeIcon className={styles.checkIcon} icon={faCheck} />}
		</div>
	);
};

interface Props {
	title: string;
	options: { id: string; label: string }[];
	value: string;
	onChange: (option: string) => void;
	closeSettings: () => void;
}

const SettingsSelect: FC<Props> = ({ title, options, value, onChange, closeSettings }) => {
	const [isOpen, setIsOpen] = useState(false);

	const closeSelect = () => {
		setIsOpen(false);
	};

	return (
		<div className={styles.container} data-cy={TestIds.Settings}>
			<SettingsItem
				icon={globe}
				label={options.find((option) => option.id === value)?.label || ''}
				actionIcon={chevronRight}
				action={() => setIsOpen(true)}
			/>
			{isOpen && (
				<>
					<div className={styles.overlay} onClick={closeSettings} />
					<div className={styles.content}>
						<div className={styles.heading}>
							<div className={styles.title}>
								<FontAwesomeIcon
									className={styles.icon}
									icon={faChevronLeft}
									onClick={closeSelect}
								/>
								{title}
							</div>
							<FontAwesomeIcon
								className={styles.icon}
								icon={faXmark}
								onClick={closeSettings}
							/>
						</div>
						<div className={styles.options}>
							{options.map(({ id, label }) => (
								<OptionItem
									key={id}
									id={id}
									label={label}
									isSelected={id === value}
									onChange={onChange}
									closeSelect={closeSelect}
								/>
							))}
						</div>
					</div>
				</>
			)}
		</div>
	);
};

export default SettingsSelect;
